import ProjectCreate from '_modules/project/views/ProjectCreate.vue';
import ProjectEdit from '_modules/project/views/ProjectEdit.vue';
import ProjectList from '_modules/project/views/ProjectList.vue';
import StatusList from '_modules/project/views/StatusList.vue';
import isCustomerMiddleware from '@/router/middlewares/isCustomerMiddleware';
import Project from './Root.vue';


export default {
  path: 'obras/',
  component: Project,
  name: 'admin-project',
  redirect: '/obras/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-project-list',
      component: ProjectList,
    },
    {
      beforeEnter: isCustomerMiddleware,
      path: 'status/lista/:page',
      name: 'admin-status-list',
      component: StatusList,
    },
    {
      beforeEnter: isCustomerMiddleware,
      path: 'novo/',
      name: 'admin-project-new',
      component: ProjectCreate,
    },
    {
      path: ':projectId/:page',
      name: 'admin-project-edit',
      component: ProjectEdit,
    },
  ],
};
